import React from "react";

export function spinningGlobeEffect(image,characterORcomicName){
    //if the image is the "not found" image, render the spinning globe effect
    //otherwise render the normal image  
    if(image === "http://i.annihil.us/u/prod/marvel/i/mg/b/40/image_not_available.jpg" || 
        image === "http://www.webnamehere.com/jarvis/images/character-not-found.gif" || 
        image === "http://www.webnamehere.com/jarvis/images/comic-not-found.gif" ){
        var imageOrNoImage = eval(<div className = "imageNotFoundContainer" >
            <div className="globeText">Searching Global Databases...</div>
            <div className = "globeTextSmaller">I can not find any images of {characterORcomicName}</div>
            <div className="spinningGlobeContainer">
                <div className="globeRing_spin"></div>
                <div className="globeRing"></div>
                <img src="http://www.webnamehere.com/jarvis/images/spinningGlobeTightCrop.gif" className="spinningGlobe"/>
            </div>
        </div>
        );                     
    }
    else{
        var imageOrNoImage = eval(<img src={image} className="characterHeadshot"/>);
    }

    return imageOrNoImage;
}


// WEBPACK FOOTER //
// ./src/components/includes/spinningGlobeEffect.js